import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { ProgressComponent } from './progress/progress.component';
import { factoryWorkerHk } from 'src/app/model/factory-worker-hk/factoryWorkerHk.model';
import Swal from 'sweetalert2'
import { UiHelper } from './progress/uiHelper';

@Component({
  selector: 'app-factory-worker-hk',
  templateUrl: './factory-worker-hk.component.html',
  styleUrls: ['./factory-worker-hk.component.scss'],
})
export class FactoryWorkerHkComponent implements OnInit, AfterViewInit {

  currentActiveStep;
  completeOnSubmit;

  imageSrc: string;
   myForm = new FormGroup({
    file: new FormControl('')
   });  
   
  factoryWorkerHk = new factoryWorkerHk();
  employmentRecord=[];


  form: FormGroup = new FormGroup({
    lastNameInput: new FormControl(''),
    firstNameInput: new FormControl(''),
    middleInitialInput: new FormControl(''),
    streeAddressInput: new FormControl(''),
    cityInput: new FormControl(''),
    barangayInput: new FormControl(''),
    zipCodeInput: new FormControl(''),
    cellNumberInput: new FormControl(''),
    genderInput: new FormControl(''),
    birthDateInput: new FormControl(''),
    birthPlaceInput: new FormControl(''),
    ageInput: new FormControl(''),
    nationalityInput: new FormControl(''),
    heightInput: new FormControl(''),
    weightInput: new FormControl(''),
    religionInput: new FormControl(''),
    statusCheckbox: new FormControl(''),
    passportInput: new FormControl(''),
    dateExpInput: new FormControl(''),
    sssIdCheckbox: new FormControl(''),
    birthCertCheckBox: new FormControl(''),
    diplomaCheckBox: new FormControl(''),
    referralCheckBox: new FormControl(''),
    fatherNameInput: new FormControl(''),
    fatherAgeInput: new FormControl(''),
    fatherJobTitleInput: new FormControl(''),
    motherNameInput: new FormControl(''),
    motherAgeInput: new FormControl(''),
    motherJobTitleInput: new FormControl(''),
    partnerNameInput: new FormControl(''),
    partnerAgeInput: new FormControl(''),
    partnerJobTitleInput: new FormControl(''),
    brotherNameInput: new FormControl(''),
    brotherAgeInput: new FormControl(''),
    brotherJobTitleInput: new FormControl(''),
    sisterNameInput: new FormControl(''),
    sisterAgeInput: new FormControl(''),
    sisterJobTitleInput: new FormControl(''),
    childrenGirlNameInput: new FormControl(''),
    childrenGirlAgeInput: new FormControl(''),
    childrenGirlJobTitleInput: new FormControl(''),
    childrenBoyNameInput: new FormControl(''),
    childrenBoyAgeInput: new FormControl(''),
    childrenBoyJobTitleInput: new FormControl(''),
    englishCheckBox: new FormControl(''),
    chineseCheckBox: new FormControl(''),
    otherCheckBox: new FormControl(''),
    elemSchoolNameInput: new FormControl(''),
    elemStatus: new FormControl(''),
    elemDateFrom: new FormControl(''),
    elemDateTo: new FormControl(''),
    highSchoolNameInput: new FormControl(''),
    highStatus: new FormControl(''),
    highDateFrom: new FormControl(''),
    highDateTo: new FormControl(''),
    collageSchoolNameInput: new FormControl(''),
    collegeStatus: new FormControl(''),
    collegeDateFrom: new FormControl(''),
    collegeDateTo: new FormControl(''),
    vocationalSchoolNameInput: new FormControl(''),
    vocationalDateFrom: new FormControl(''),
    vocationalDateto: new FormControl(''),
    erEmployersNameInput: new FormControl(''),
    erPlaceInput: new FormControl(''),
    erPositionInput: new FormControl(''),
    erDateInput: new FormControl(''),
    
  });
  
  ngAfterViewInit() {}

  ngOnInit() {
    this.employmentRecord.push(this.factoryWorkerHk)
  }
  
  // Add Employment Record 
  addEmpRecord() {
    this.factoryWorkerHk = new factoryWorkerHk()
    this.employmentRecord.push(this.factoryWorkerHk)
  }

  onSubmit(): void {
    console.log(this.form.value)
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Application has been submitted',
      showConfirmButton: false,
      timer: 1500
    })
  }

  getCurrentStep(event: any) {
    this.currentActiveStep = event.activeIndex;
    this.completeOnSubmit = event.activeStep;
    console.log(this.currentActiveStep);
    console.log(this.completeOnSubmit)
  }

  
}
